var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notes"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Guides"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.733061,0,0,0.733061,-9.35981,119.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbols"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Thin-L"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.313,11.768L179.834,11.768C182.324,11.768 184.082,9.961 184.082,7.422C184.082,4.932 182.324,3.076 179.834,3.076L166.064,3.076L166.064,-70.019C166.064,-78.027 161.963,-82.08 154.004,-82.08L46.143,-82.08C38.232,-82.08 34.082,-78.027 34.082,-70.019L34.082,3.076L20.313,3.076C17.822,3.076 16.064,4.932 16.064,7.422C16.064,9.961 17.822,11.768 20.313,11.768ZM38.037,-69.58C38.037,-75.342 40.918,-78.174 46.631,-78.174L153.516,-78.174C159.277,-78.174 162.158,-75.342 162.158,-69.58L162.158,3.076L38.037,3.076L38.037,-69.58Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.1ec67f820482dbc4c004555f660fa3d8.svg";
export { ForwardRef as ReactComponent };